"use client";

import { useEffect } from "react";

export default function GlobalError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	useEffect(() => {
		// Log to console; production error tracking can hook in later
		console.error("[global-error]", error);
	}, [error]);

	return (
		<html lang="en">
			<body>
				<main
					style={{
						minHeight: "100vh",
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						background: "#0a0a0a",
						color: "#dcdcdc",
						fontFamily: "Inter, sans-serif",
						padding: 24,
					}}
				>
					<h1 style={{ fontSize: 24, marginBottom: 8 }}>
						문제가 발생했어요
					</h1>
					<p style={{ color: "rgba(255,255,255,0.6)", marginBottom: 24, textAlign: "center" }}>
						예기치 못한 오류가 발생했습니다. 다시 시도해 주세요.
					</p>
					<button
						type="button"
						onClick={reset}
						style={{
							padding: "8px 20px",
							background: "#d4af37",
							color: "#0a0a0a",
							border: "none",
							borderRadius: 6,
							fontWeight: 600,
							cursor: "pointer",
						}}
					>
						다시 시도
					</button>
					{error.digest && (
						<p style={{ marginTop: 16, fontSize: 11, color: "rgba(255,255,255,0.4)", fontFamily: "monospace" }}>
							{error.digest}
						</p>
					)}
				</main>
			</body>
		</html>
	);
}
